<footer class="footer">
  <hr />
  <div class="footer_controls" [class.footer_right_controls]="!isBackBtnVisible">
    <div *ngIf="isBackBtnVisible">
      <button type="button" class="btn btn-primary footer_controls_btn_left" (click)="previousStep()">
        <i class="fas fa-angle-left"></i>
        {{ 'MyProfile_Back' | translate }}
      </button>
    </div>
    <div>
      <button type="button" class="btn btn-primary" (click)="nextStep()" [disabled]="!isNextBtnDisabled">
        {{ 'MyProfile_Next' | translate }}
      </button>
    </div>
  </div>
</footer>
